import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=799d7632&scoped=true"
import script from "./BranchEdit.vue?vue&type=script&lang=ts"
export * from "./BranchEdit.vue?vue&type=script&lang=ts"
import style0 from "./BranchEdit.vue?vue&type=style&index=0&id=799d7632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d7632",
  null
  
)

export default component.exports